import { Link } from 'react-router-dom';

export function Landing() {
  return (
    <div>
      <section className="hero">
        <div className="badge muted" style={{ marginBottom: 16 }}>🔐 Zero-knowledge by design</div>
        <h1>
          Your passwords, <span className="gradient-text">encrypted in your browser.</span>
          <br /> Even we can&apos;t read them.
        </h1>
        <p>
          Battini Vault is a zero-knowledge password manager. Your master password and vault
          secrets are encrypted client-side with Argon2id + AES-256-GCM. The server only ever
          stores ciphertext — it never sees, and cannot decrypt, your data.
        </p>
        <div className="flex wrap" style={{ justifyContent: 'center', gap: 12 }}>
          <Link to="/register" className="btn">Get started — it&apos;s free</Link>
          <Link to="/login" className="btn secondary">Sign in</Link>
        </div>
      </section>

      <section className="cards" style={{ maxWidth: 980, margin: '0 auto 60px', padding: '0 24px' }}>
        {[
          ['🔑', 'Zero-knowledge', 'Master password derives your keys locally. The server stores only encrypted blobs + salts — never plaintext or keys.'],
          ['🛡️', 'Strong crypto', 'Argon2id key derivation, AES-256-GCM authenticated encryption, RSA-OAEP for secure sharing.'],
          ['📤', 'Secure sharing', 'Share items with recipient-specific keys. Revocation is instant; the server learns nothing.'],
          ['🏢', 'Teams & policies', 'Organisations, roles, shared collections, audit logs, and policy enforcement (MFA, strength, timeout).'],
        ].map(([icon, title, body]) => (
          <div className="stat" key={title}>
            <div style={{ fontSize: 26 }}>{icon}</div>
            <div style={{ fontWeight: 700, marginTop: 8 }}>{title}</div>
            <div className="muted" style={{ fontSize: 13, marginTop: 6 }}>{body}</div>
          </div>
        ))}
      </section>
    </div>
  );
}
